export default {
  colorPrimary: {
    backgroundColor: 'rgba(33,43,54,0.75)'
  }
};
